import azTax from "../images/azTaxBG.png";
import rrPizza from "../images/rrPizzaBG.png";
import street from "../images/streetBG.png";
import origPort from "../images/origPortBG.png";
import jroAsst from "../images/jroAsstBG.png";
import abacus from "../images/abacus.png";

const ProjectsList = [
  {
    id: 1,
    alt: "Placeholder alt",
    title: "AZ Tax and Business",
    subtitle: "Freelance Site",
    git: "https://github.com/8BitJustin/Taxsite2018",
    site: "http://www.arizonataxandbusiness.com/",
    image: azTax,
  },
  {
    id: 2,
    alt: "Placeholder alt",
    title: "R & R Pizza Express",
    subtitle: "Freelance Site",
    git: "https://github.com/8BitJustin/R-R-Pizza-Website",
    site: "https://www.rrpizzamarana.com/",
    image: rrPizza,
  },
  {
    id: 3,
    alt: "Placeholder alt",
    title: "Street Taco",
    subtitle: "Personal Site",
    git: "https://github.com/8BitJustin/Street-Taco-Site",
    site: "https://sttacosite.netlify.com/",
    image: street,
  },
  {
    id: 4,
    alt: "Placeholder alt",
    title: "Original Portfolio",
    subtitle: "Personal Site",
    git: "https://github.com/8BitJustin/Portfolio-Website-3",
    site: "https://olderportfolio.netlify.com/",
    image: origPort,
  },
  {
    id: 5,
    alt: "Placeholder alt",
    title: "JRO Assistance Form",
    subtitle: "Work Site",
    git: "https://github.com/8BitJustin/JRO-Assistance-Form",
    site: "https://jroassistanceform.netlify.app",
    image: jroAsst,
  },
  {
    id: 6,
    alt: "Placeholder alt",
    title: "Loot Abacus (Tip Calc)",
    subtitle: "Mobile App",
    git: "https://github.com/8BitJustin/Loot-Abacus",
    site: "",
    image: abacus,
  },
];

export default ProjectsList;
